import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_c9938d68-1681-4c70-a0d0-2eb4390b972e/artifacts/7as7vd01_White%20logo%20-%20no%20background.svg"
              alt="RHE Project Consulting"
              className="h-14 w-auto mb-4" />

            <p className="text-slate-400 text-sm leading-relaxed">
              RHE Project Consulting provides specialist project management services supporting the delivery of infrastructure and capital works programs across NSW.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#capabilities" className="text-slate-400 hover:text-white transition-colors duration-200">
                  Capabilities
                </a>
              </li>
              <li>
                <a href="#projects" className="text-slate-400 hover:text-white transition-colors duration-200">
                  Project Experience
                </a>
              </li>
              <li>
                <a href="#team" className="text-slate-400 hover:text-white transition-colors duration-200">

                </a>
              </li>
              <li>
                <a href="#contact" className="text-slate-400 hover:text-white transition-colors duration-200">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Information</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-slate-400 mt-0.5 flex-shrink-0" />
                <a href="tel:+61400106677" className="text-slate-400 hover:text-white transition-colors duration-200">
                  +61 400 106 677
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-slate-400 mt-0.5 flex-shrink-0" />
                <a href="mailto:admin@rheprojectconsulting.com.au" className="text-slate-400 hover:text-white transition-colors duration-200 break-all">
                  admin@rheprojectconsulting.com.au
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-slate-400 mt-0.5 flex-shrink-0" />
                <span className="text-slate-400">Serving, Australia

                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            &copy; {new Date().getFullYear()} RHE Project Consulting. All rights reserved.
          </p>
          <p className="text-slate-500 text-xs mt-2">
            rheprojectconsulting.com.au
          </p>
        </div>
      </div>
    </footer>);

};